module.exports = __webpack_public_path__ + "img/section3Card3Icon2.2ab7f316.png";